var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg542",
    width: 880,
    height: 880,
    viewBox: "0 0 880 880",
    sodipodiDocname: "cherry-cake-publicdomainvectors.org.svg",
    inkscapeVersion: "1.2 (dc2aedaf03, 2022-05-15)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs546"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,660 H 660 V 0 H 0 Z",
    id: "path556"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview544",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 0.95113636,
    inkscapeCx: 440.52569,
    inkscapeCy: 440.52569,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g550"
  }, /*#__PURE__*/React.createElement("inkscapePage", {
    x: 0,
    y: 0,
    id: "page548",
    width: 880,
    height: 880
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g550",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Page 1",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,880)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g554",
    clipPath: "url(#clipPath558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g560",
    transform: "translate(373.498,108.4902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 114.675,0 208.202,37.121 208.202,82.634 0,45.513 -93.527,82.634 -208.202,82.634 -114.672,0 -208.199,-37.121 -208.199,-82.634 C -208.199,37.121 -114.672,0 0,0",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path562"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g564",
    transform: "translate(531.9883,470.5771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.699,0 26.687,11.988 26.687,26.687 0,14.7 -11.988,26.688 -26.687,26.688 -14.699,0 -26.687,-11.988 -26.687,-26.688 C -26.687,11.988 -14.699,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g568",
    transform: "translate(506.5781,511.7754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.061,0 20.086,9.023 20.086,20.085 0,11.063 -9.025,20.086 -20.086,20.086 -11.064,0 -20.086,-9.023 -20.086,-20.086 C -20.086,9.023 -11.064,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g572",
    transform: "translate(457.0439,515.4648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 18.446,0 33.489,15.044 33.489,33.489 33.489,51.934 18.446,66.978 0,66.978 -18.443,66.978 -33.485,51.934 -33.485,33.489 -33.485,15.044 -18.443,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path574"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g576",
    transform: "translate(405.4297,541.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.422,0 26.181,11.76 26.181,26.18 26.181,40.6 14.422,52.361 0,52.361 -14.42,52.361 -26.181,40.6 -26.181,26.18 -26.181,11.76 -14.42,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g580",
    transform: "translate(347.5879,536.6611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 21.643,0 39.292,17.65 39.292,39.292 39.292,60.934 21.643,78.585 0,78.585 -21.643,78.585 -39.292,60.934 -39.292,39.292 -39.292,17.65 -21.643,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path582"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g584",
    transform: "translate(301.7979,557.0938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.721,0 15.835,7.114 15.835,15.834 0,8.721 -7.114,15.833 -15.835,15.833 -8.721,0 -15.834,-7.112 -15.834,-15.833 C -15.834,7.114 -8.721,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path586"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g588",
    transform: "translate(257.3379,536.8931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 18.445,0 33.488,15.044 33.488,33.489 33.488,51.933 18.445,66.976 0,66.976 -18.443,66.976 -33.489,51.933 -33.489,33.489 -33.489,15.044 -18.443,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path590"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g592",
    transform: "translate(208.0479,525.7412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.697,0 26.687,11.988 26.687,26.686 26.687,41.387 14.697,53.375 0,53.375 -14.702,53.375 -26.687,41.387 -26.687,26.686 -26.687,11.988 -14.702,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path594"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g596",
    transform: "translate(167.3008,528.2627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.226,0 20.382,9.155 20.382,20.383 0,11.226 -9.156,20.383 -20.382,20.383 -11.228,0 -20.384,-9.157 -20.384,-20.383 C -20.384,9.155 -11.228,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g600",
    transform: "translate(135.501,475.4727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.699,0 26.688,11.99 26.688,26.687 0,14.7 -11.989,26.688 -26.688,26.688 -14.699,0 -26.688,-11.988 -26.688,-26.688 C -26.688,11.99 -14.699,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g604",
    transform: "translate(149.2188,510.5786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.72,0 15.833,7.114 15.833,15.835 0,8.72 -7.113,15.833 -15.833,15.833 -8.722,0 -15.834,-7.113 -15.834,-15.833 C -15.834,7.114 -8.722,0 0,0",
    style: {
      fill: "#f07c00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path606"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g608",
    transform: "translate(127.4434,488.1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 416.4 v -268.603 c 0,-138.799 -416.4,-138.799 -416.4,0 z",
    style: {
      fill: "#823103",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path610"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g612",
    transform: "translate(127.4434,488.1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 416.4 v -268.603 c 0,-105.225 -239.28,-130.651 -355.056,-76.333 60.38,-12.83 114.542,-8.133 177.189,5.284 75.546,17.322 139.542,39.413 137.917,127.565 -1.834,16.243 -3.131,26.79 -9.83,42.023 -26.628,60.556 -73.084,61.737 -130.627,55.323 -17.79,-1.638 -35.809,-3.526 -53.652,-4.182 C 96.558,-122.076 49.31,-73.694 0,-33.952 Z",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path614"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g616",
    transform: "translate(151.8887,324.4844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 19.266,78.865 93.775,33.669 147.801,19.581 203.643,5.02 339.025,-21.244 263.471,-107.346 203.026,-176.226 47.149,-220.682 5.007,-106.105 -7.141,-73.074 -7.166,-34.134 0,0",
    style: {
      fill: "#9c420e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path618"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g620",
    transform: "translate(335.6445,405.5029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 114.672,0 208.199,37.12 208.199,82.634 0,45.513 -93.527,82.635 -208.199,82.635 -114.672,0 -208.201,-37.122 -208.201,-82.635 C -208.201,37.12 -114.672,0 0,0",
    style: {
      fill: "#bd591e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path622"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g624",
    transform: "translate(135.501,449.0352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.699,0 26.688,11.988 26.688,26.687 0,14.7 -11.989,26.688 -26.688,26.688 -14.699,0 -26.688,-11.988 -26.688,-26.688 C -26.688,11.988 -14.699,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g628",
    transform: "translate(160.9121,421.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 11.064,0 20.086,9.022 20.086,20.084 20.086,31.147 11.064,40.17 0,40.17 -11.063,40.17 -20.086,31.147 -20.086,20.084 -20.086,9.022 -11.063,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path630"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g632",
    transform: "translate(210.4463,390.5449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 18.443,0 33.486,15.044 33.486,33.488 33.486,51.934 18.443,66.976 0,66.976 -18.446,66.976 -33.489,51.934 -33.489,33.488 -33.489,15.044 -18.446,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g636",
    transform: "translate(262.0586,379.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.422,0 26.18,11.761 26.18,26.181 0,14.42 -11.758,26.18 -26.18,26.18 -14.42,0 -26.181,-11.76 -26.181,-26.18 C -26.181,11.761 -14.42,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path638"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g640",
    transform: "translate(319.9023,357.7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 21.641,0 39.292,17.651 39.292,39.293 39.292,60.935 21.641,78.586 0,78.586 -21.642,78.586 -39.294,60.935 -39.294,39.293 -39.294,17.651 -21.642,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path642"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g644",
    transform: "translate(365.6924,384.2246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.721,0 15.832,7.113 15.832,15.835 0,8.721 -7.111,15.833 -15.832,15.833 -8.721,0 -15.832,-7.112 -15.832,-15.833 C -15.832,7.113 -8.721,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path646"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g648",
    transform: "translate(410.1504,369.1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 18.445,0 33.488,15.044 33.488,33.488 0,18.445 -15.043,33.49 -33.488,33.49 -18.443,0 -33.486,-15.045 -33.486,-33.49 C -33.486,15.044 -18.443,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path650"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g652",
    transform: "translate(459.4424,393.8711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.699,0 26.687,11.988 26.687,26.687 0,14.7 -11.988,26.688 -26.687,26.688 -14.696,0 -26.686,-11.988 -26.686,-26.688 C -26.686,11.988 -14.696,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path654"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g656",
    transform: "translate(500.1895,403.959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.228,0 20.385,9.155 20.385,20.383 0,11.226 -9.157,20.383 -20.385,20.383 -11.228,0 -20.384,-9.157 -20.384,-20.383 C -20.384,9.155 -11.228,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path658"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g660",
    transform: "translate(531.9883,444.1396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.699,0 26.687,11.988 26.687,26.686 26.687,41.385 14.699,53.374 0,53.374 -14.699,53.374 -26.687,41.385 -26.687,26.686 -26.687,11.988 -14.699,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g664",
    transform: "translate(518.2705,430.7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.723,0 15.834,7.113 15.834,15.834 0,8.721 -7.111,15.833 -15.834,15.833 -8.721,0 -15.832,-7.112 -15.832,-15.833 C -15.832,7.113 -8.721,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g668",
    transform: "translate(557.584,371.3809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.692,-94.172 -147.526,-117.194 -221.941,-117.194 -74.414,0 -221.249,23.021 -221.94,117.194 -0.37,7.85 5.872,21.698 13.74,21.698 V 0.663 c 0,-73.466 150.689,-90.344 208.2,-90.344 57.511,0 208.201,16.878 208.201,90.344 V 21.698 C -5.872,21.698 0.369,7.85 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path670"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g672",
    transform: "translate(348.0645,219.8877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.696,0 26.688,11.986 26.688,26.686 26.688,41.384 14.696,53.374 0,53.374 -14.699,53.374 -26.687,41.384 -26.687,26.686 -26.687,11.986 -14.699,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g676",
    transform: "translate(310.6016,231.1699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.721,0 15.832,7.112 15.832,15.834 0,8.719 -7.111,15.833 -15.832,15.833 -8.721,0 -15.834,-7.114 -15.834,-15.833 C -15.834,7.112 -8.721,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path678"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g680",
    transform: "translate(233.3799,272.8643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.227,0 20.384,9.155 20.384,20.383 0,11.226 -9.157,20.384 -20.384,20.384 -11.228,0 -20.384,-9.158 -20.384,-20.384 C -20.384,9.155 -11.228,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path682"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g684",
    transform: "translate(173.2607,258.3359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.064,0 20.085,9.022 20.085,20.085 0,11.063 -9.021,20.086 -20.085,20.086 -11.061,0 -20.086,-9.023 -20.086,-20.086 C -20.086,9.022 -11.061,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g688",
    transform: "translate(238.3516,206.7783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 18.443,0 33.486,15.044 33.486,33.488 0,18.445 -15.043,33.49 -33.486,33.49 -18.445,0 -33.488,-15.045 -33.488,-33.49 C -33.488,15.044 -18.445,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path690"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g692",
    transform: "translate(429.2617,215.1523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 16.538,0 30.029,13.488 30.029,30.029 30.029,46.568 16.538,60.06 0,60.06 -16.54,60.06 -30.031,46.568 -30.031,30.029 -30.031,13.488 -16.54,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path694"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g696",
    transform: "translate(544.752,305.0576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.721,0 15.834,7.113 15.834,15.834 0,8.72 -7.113,15.834 -15.834,15.834 -8.721,0 -15.832,-7.114 -15.832,-15.834 C -15.832,7.113 -8.721,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path698"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g700",
    transform: "translate(508.9453,249.7324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.697,0 26.688,11.988 26.688,26.686 0,14.7 -11.991,26.689 -26.688,26.689 -14.699,0 -26.687,-11.989 -26.687,-26.689 C -26.687,11.988 -14.699,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path702"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g704",
    transform: "translate(507.6709,297.6504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.721,0 15.832,7.113 15.832,15.834 0,8.721 -7.111,15.833 -15.832,15.833 -8.721,0 -15.835,-7.112 -15.835,-15.833 C -15.835,7.113 -8.721,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path706"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g708",
    transform: "translate(456.833,215.6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.943,0 25.318,11.372 25.318,25.316 25.318,39.262 13.943,50.634 0,50.634 -13.942,50.634 -25.317,39.262 -25.317,25.316 -25.317,11.372 -13.942,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path710"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g712",
    transform: "translate(125.3096,312.1758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.698,0 26.686,11.989 26.686,26.687 0,14.7 -11.988,26.688 -26.686,26.688 -14.699,0 -26.687,-11.988 -26.687,-26.688 C -26.687,11.989 -14.699,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path714"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g716",
    transform: "translate(332.5947,260.5186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.422,0 26.181,11.76 26.181,26.18 26.181,40.6 14.422,52.36 0,52.36 -14.417,52.36 -26.181,40.6 -26.181,26.18 -26.181,11.76 -14.417,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path718"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g720",
    transform: "translate(386.4961,223.5303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.223,0 24.008,10.786 24.008,24.011 24.008,37.234 13.223,48.019 0,48.019 -13.226,48.019 -24.01,37.234 -24.01,24.011 -24.01,10.786 -13.226,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path722"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g724",
    transform: "translate(475.3975,243.6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.943,0 25.315,11.373 25.315,25.318 25.315,39.262 13.943,50.635 0,50.635 -13.943,50.635 -25.317,39.262 -25.317,25.318 -25.317,11.373 -13.943,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path726"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g728",
    transform: "translate(461.2051,244.0234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 13.943,0 25.318,11.374 25.318,25.317 25.318,39.262 13.943,50.635 0,50.635 -13.943,50.635 -25.317,39.262 -25.317,25.317 -25.317,11.374 -13.943,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g732",
    transform: "translate(534.9717,267.0693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.42,0 26.181,11.761 26.181,26.181 26.181,40.602 14.42,52.362 0,52.362 -14.419,52.362 -26.18,40.602 -26.18,26.181 -26.18,11.761 -14.419,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path734"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g736",
    transform: "translate(275.8145,217.5693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.419,0 26.181,11.759 26.181,26.179 26.181,40.6 14.419,52.36 0,52.36 -14.42,52.36 -26.183,40.6 -26.183,26.179 -26.183,11.759 -14.42,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path738"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g740",
    transform: "translate(206.2324,241.8955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 12.183,0 22.119,9.937 22.119,22.119 0,12.182 -9.936,22.118 -22.119,22.118 -12.18,0 -22.118,-9.936 -22.118,-22.118 C -22.118,9.937 -12.18,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path742"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g744",
    transform: "translate(136.4072,273.2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.419,0 26.181,11.761 26.181,26.181 26.181,40.6 14.419,52.362 0,52.362 -14.42,52.362 -26.181,40.6 -26.181,26.181 -26.181,11.761 -14.42,0 0,0",
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g748",
    transform: "translate(116.4717,331.6934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.043,0 10.972,4.929 10.972,10.972 0,6.043 -4.929,10.971 -10.972,10.971 -6.043,0 -10.972,-4.928 -10.972,-10.971 C -10.972,4.929 -6.043,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path750"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g752",
    transform: "translate(132.8008,292.123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.214,0 11.283,5.068 11.283,11.283 0,6.215 -5.069,11.283 -11.283,11.283 -6.215,0 -11.284,-5.068 -11.284,-11.283 C -11.284,5.068 -6.215,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path754"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g756",
    transform: "translate(164.8906,275.3789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.189,0 7.607,3.417 7.607,7.606 0,4.19 -3.418,7.607 -7.607,7.607 -4.189,0 -7.606,-3.417 -7.606,-7.607 C -7.606,3.417 -4.189,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path758"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g760",
    transform: "translate(201.7637,253.9043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.121,0 9.299,4.178 9.299,9.3 0,5.123 -4.178,9.302 -9.299,9.302 -5.124,0 -9.304,-4.179 -9.304,-9.302 C -9.304,4.178 -5.124,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g764",
    transform: "translate(234.8965,287.7559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.114,0 9.282,4.168 9.282,9.28 0,5.113 -4.168,9.282 -9.282,9.282 -5.109,0 -9.279,-4.169 -9.279,-9.282 C -9.279,4.168 -5.109,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path766"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g768",
    transform: "translate(233.2617,219.6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 8.019,0 14.56,6.541 14.56,14.561 14.56,22.578 8.019,29.12 0,29.12 -8.02,29.12 -14.56,22.578 -14.56,14.561 -14.56,6.541 -8.02,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path770"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g772",
    transform: "translate(277.8496,226.6055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 5.512,0 10.01,4.495 10.01,10.01 10.01,15.522 5.512,20.02 0,20.02 -5.514,20.02 -10.01,15.522 -10.01,10.01 -10.01,4.495 -5.514,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path774"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g776",
    transform: "translate(304.7744,247.0039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.91,0 8.91,4.001 8.91,8.91 0,4.907 -4,8.91 -8.91,8.91 -4.905,0 -8.91,-4.003 -8.91,-8.91 C -8.91,4.001 -4.905,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path778"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g780",
    transform: "translate(328.1943,281.7012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.377,0 11.58,5.201 11.58,11.581 0,6.378 -5.203,11.58 -11.58,11.58 -6.377,0 -11.581,-5.202 -11.581,-11.58 C -11.581,5.201 -6.377,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path782"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g784",
    transform: "translate(340.6563,228.0615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 7.219,0 13.104,5.887 13.104,13.106 0,7.219 -5.885,13.107 -13.104,13.107 -7.221,0 -13.109,-5.888 -13.109,-13.107 C -13.109,5.887 -7.221,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path786"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g788",
    transform: "translate(384.1875,227.6982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.199,0 9.439,4.238 9.439,9.437 0,5.199 -4.24,9.438 -9.439,9.438 -5.199,0 -9.439,-4.239 -9.439,-9.438 C -9.439,4.238 -5.199,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path790"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g792",
    transform: "translate(421.1172,231.6992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.683,0 12.133,5.45 12.133,12.133 0,6.682 -5.45,12.133 -12.133,12.133 -6.683,0 -12.133,-5.451 -12.133,-12.133 C -12.133,5.45 -6.683,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path794"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g796",
    transform: "translate(451.8262,245.1816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.512,0 11.822,5.311 11.822,11.822 0,6.512 -5.31,11.823 -11.822,11.823 -6.512,0 -11.822,-5.311 -11.822,-11.823 C -11.822,5.311 -6.512,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path798"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g800",
    transform: "translate(503.957,298.4834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.915,0 10.74,4.824 10.74,10.739 0,5.915 -4.825,10.739 -10.74,10.739 -5.914,0 -10.739,-4.824 -10.739,-10.739 C -10.739,4.824 -5.914,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path802"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g804",
    transform: "translate(548.6621,316.8721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 2.653,0 4.817,2.164 4.817,4.817 4.817,7.472 2.653,9.636 0,9.636 -2.654,9.636 -4.818,7.472 -4.818,4.817 -4.818,2.164 -2.654,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path806"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g808",
    transform: "translate(537.1875,279.0186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 5.614,0 10.192,4.577 10.192,10.19 10.192,15.805 5.614,20.383 0,20.383 -5.611,20.383 -10.19,15.805 -10.19,10.19 -10.19,4.577 -5.611,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path810"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g812",
    transform: "translate(501.3369,256.4521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.514,0 11.829,5.312 11.829,11.828 0,6.516 -5.315,11.829 -11.829,11.829 -6.518,0 -11.83,-5.313 -11.83,-11.829 C -11.83,5.312 -6.518,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path814"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g816",
    transform: "translate(365.7607,447.1787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 65.556,0 119.023,21.419 119.023,47.682 119.023,73.944 65.556,95.364 0,95.364 -65.556,95.364 -119.022,73.944 -119.022,47.682 -119.022,21.419 -65.556,0 0,0",
    style: {
      fill: "#ad460a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g820",
    transform: "translate(124.0684,469.5972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.497,0 11.796,5.3 11.796,11.797 0,6.497 -5.299,11.798 -11.796,11.798 -6.498,0 -11.798,-5.301 -11.798,-11.798 C -11.798,5.3 -6.498,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path822"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g824",
    transform: "translate(156.8271,433.0078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 7.037,0 12.779,5.74 12.779,12.778 0,7.038 -5.742,12.779 -12.779,12.779 -7.038,0 -12.779,-5.741 -12.779,-12.779 C -12.779,5.74 -7.038,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path826"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g828",
    transform: "translate(202.6875,412.6006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 10.827,0 19.656,8.829 19.656,19.654 0,10.828 -8.829,19.657 -19.656,19.657 -10.825,0 -19.654,-8.829 -19.654,-19.657 C -19.654,8.829 -10.825,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path830"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g832",
    transform: "translate(256.6553,401.6816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 7.104,0 12.9,5.795 12.9,12.9 12.9,20.004 7.104,25.799 0,25.799 -7.105,25.799 -12.9,20.004 -12.9,12.9 -12.9,5.795 -7.105,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path834"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g836",
    transform: "translate(310.248,384.9385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.927,0 21.654,9.729 21.654,21.658 0,11.928 -9.727,21.656 -21.654,21.656 -11.929,0 -21.659,-9.728 -21.659,-21.656 C -21.659,9.729 -11.929,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path838"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g840",
    transform: "translate(363.7539,391.9766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.548,0 10.068,4.522 10.068,10.068 0,5.547 -4.52,10.071 -10.068,10.071 -5.548,0 -10.069,-4.524 -10.069,-10.071 C -10.069,4.522 -5.548,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g844",
    transform: "translate(400.6074,389.6709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 10.375,0 18.837,8.461 18.837,18.835 18.837,29.21 10.375,37.672 0,37.672 -10.374,37.672 -18.837,29.21 -18.837,18.835 -18.837,8.461 -10.374,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path846"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g848",
    transform: "translate(452.9307,405.3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 9.523,0 17.292,7.767 17.292,17.29 17.292,26.812 9.523,34.579 0,34.579 -9.522,34.579 -17.289,26.812 -17.289,17.29 -17.289,7.767 -9.522,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g852",
    transform: "translate(494.5166,418.4258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.365,0 11.557,5.19 11.557,11.556 0,6.366 -5.192,11.557 -11.557,11.557 -6.365,0 -11.555,-5.191 -11.555,-11.557 C -11.555,5.19 -6.365,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path854"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g856",
    transform: "translate(512.626,438.9912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.41,0 8.007,3.596 8.007,8.007 0,4.41 -3.597,8.009 -8.007,8.009 -4.41,0 -8.008,-3.599 -8.008,-8.009 C -8.008,3.596 -4.41,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path858"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g860",
    transform: "translate(522.2705,468.4727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.216,0 11.284,5.069 11.284,11.283 0,6.216 -5.068,11.285 -11.284,11.285 -6.214,0 -11.282,-5.069 -11.282,-11.285 C -11.282,5.069 -6.214,0 0,0",
    style: {
      fill: "#ffb940",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path862"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g864",
    transform: "translate(332.9971,451.9121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 65.559,0 119.026,21.419 119.026,47.681 119.026,73.943 65.559,95.364 0,95.364 -65.555,95.364 -119.021,73.943 -119.021,47.681 -119.021,21.419 -65.555,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g868",
    transform: "translate(256.8594,500.6851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 12.568,0 22.822,10.253 22.822,22.824 22.822,35.394 12.568,45.646 0,45.646 -12.571,45.646 -22.825,35.394 -22.825,22.824 -22.825,10.253 -12.571,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g872",
    transform: "translate(274.8213,528.3999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 9.977,0 18.111,8.137 18.111,18.113 0,9.975 -8.134,18.112 -18.111,18.112 -9.977,0 -18.114,-8.137 -18.114,-18.112 C -18.114,8.137 -9.977,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path874"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g876",
    transform: "translate(296.7813,521.4331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 9.322,0 16.927,7.603 16.927,16.926 0,9.322 -7.605,16.925 -16.927,16.925 -9.322,0 -16.927,-7.603 -16.927,-16.925 C -16.927,7.603 -9.322,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g880",
    transform: "translate(318.9854,525.437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 14.133,0 25.661,11.527 25.661,25.66 25.661,39.794 14.133,51.322 0,51.322 -14.133,51.322 -25.661,39.794 -25.661,25.66 -25.661,11.527 -14.133,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path882"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g884",
    transform: "translate(296.791,546.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.324,0 15.113,6.79 15.113,15.114 0,8.324 -6.789,15.115 -15.113,15.115 -8.325,0 -15.114,-6.791 -15.114,-15.115 C -15.114,6.79 -8.325,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g888",
    transform: "translate(350.1064,520.3408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 11.228,0 20.382,9.156 20.382,20.383 20.382,31.61 11.228,40.767 0,40.767 -11.227,40.767 -20.384,31.61 -20.384,20.383 -20.384,9.156 -11.227,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path890"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g892",
    transform: "translate(350.4717,542.1787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.427,0 20.744,9.321 20.744,20.748 0,11.428 -9.317,20.748 -20.744,20.748 -11.429,0 -20.749,-9.32 -20.749,-20.748 C -20.749,9.321 -11.429,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path894"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g896",
    transform: "translate(376.8584,519.6284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.126,0 20.202,9.075 20.202,20.202 0,11.126 -9.076,20.2 -20.202,20.2 -11.126,0 -20.202,-9.074 -20.202,-20.2 C -20.202,9.075 -11.126,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path898"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g900",
    transform: "translate(403.3379,507.0718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 14.585,0 26.48,11.895 26.48,26.479 0,14.584 -11.895,26.48 -26.48,26.48 -14.584,0 -26.479,-11.896 -26.479,-26.48 C -26.479,11.895 -14.584,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path902"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g904",
    transform: "translate(432.7314,509.0576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 7.817,0 14.194,6.376 14.194,14.194 0,7.819 -6.377,14.197 -14.194,14.197 -7.82,0 -14.197,-6.378 -14.197,-14.197 C -14.197,6.376 -7.82,0 0,0",
    style: {
      fill: "#5e2200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path906"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g908",
    transform: "translate(247.252,521.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 10.488,4.244 23.903,-0.219 29.968,-9.969 6.061,-9.751 2.473,-21.095 -8.01,-25.339 C 11.47,-39.55 -1.945,-35.087 -8.007,-25.337 -14.071,-15.587 -10.483,-4.243 0,0",
    style: {
      fill: "#ff6666",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path910"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g912",
    transform: "translate(264.1904,527.9795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -10.483,-4.244 -17.019,-16.781 -14.595,-28.003 2.425,-11.223 12.889,-16.88 23.377,-12.636 10.487,4.244 17.02,16.781 14.596,28.004 C 20.953,-1.414 10.488,4.243 0,0",
    style: {
      fill: "#ff6666",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path914"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g916",
    transform: "translate(322.0752,551.4927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 11.269,1.014 22.807,-7.155 25.775,-18.246 2.967,-11.091 -3.76,-20.904 -15.028,-21.917 -11.266,-1.014 -22.804,7.156 -25.773,18.246 C -17.993,-10.825 -11.268,-1.013 0,0",
    style: {
      fill: "#ff6666",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path918"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g920",
    transform: "translate(340.2754,553.1304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -11.269,-1.013 -21.164,-11.112 -22.103,-22.554 -0.943,-11.442 7.429,-19.896 18.697,-18.883 11.265,1.013 21.162,11.112 22.102,22.554 C 19.637,-7.44 11.268,1.013 0,0",
    style: {
      fill: "#ff6666",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path922"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g924",
    transform: "translate(393.7949,536.2261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 10.607,-3.931 17.51,-16.271 15.419,-27.56 13.327,-38.849 3.03,-44.813 -7.576,-40.88 c -10.607,3.932 -17.51,16.271 -15.417,27.56 C -20.901,-2.031 -10.604,3.933 0,0",
    style: {
      fill: "#ff6666",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g928",
    transform: "translate(410.9297,529.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -10.607,3.932 -23.884,-0.925 -29.656,-10.851 -5.774,-9.925 -1.854,-21.157 8.753,-25.09 10.607,-3.932 23.884,0.926 29.657,10.851 C 14.526,-15.165 10.607,-3.932 0,0",
    style: {
      fill: "#ff6666",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path930"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.023ef0df41c9c7e3874596b03db5d15c.svg";
export { ForwardRef as ReactComponent };